import { FieldFieldType, InputFieldInputType, InputFieldStringComponentType } from '@wix/ambassador-forms-v4-form/types';
const FIRST_NAME_FIELD_ID = 'f845502f-b248-4c86-c784-9a7e5111c9fb';
const LAST_NAME_FIELD_ID = 'd7a77011-2501-4b61-2141-5ba30e8a3b1e';
const FORM_ID = 'b55bcb0c-485c-4708-ae2b-d3c0e1991107';
const STEP_ID = '7f8269c9-430f-4ec5-bcea-8911e24cdd93';
export function createFullNameFormSchema(isJapanOrder, validation) {
  var _validation$object, _validation$object2;
  const parentRequired = (validation == null ? void 0 : validation.required) ?? false;
  const firstNameRequired = (validation == null || (_validation$object = validation.object) == null || (_validation$object = _validation$object.properties) == null || (_validation$object = _validation$object.first_name) == null ? void 0 : _validation$object.required) ?? parentRequired;
  const lastNameRequired = (validation == null || (_validation$object2 = validation.object) == null || (_validation$object2 = _validation$object2.properties) == null || (_validation$object2 = _validation$object2.last_name) == null ? void 0 : _validation$object2.required) ?? parentRequired;
  const [leftId, rightId] = isJapanOrder ? [LAST_NAME_FIELD_ID, FIRST_NAME_FIELD_ID] : [FIRST_NAME_FIELD_ID, LAST_NAME_FIELD_ID];
  return {
    id: FORM_ID,
    fields: [{
      id: FIRST_NAME_FIELD_ID,
      target: 'first_name',
      pii: true,
      validation: {
        string: {},
        required: firstNameRequired
      },
      view: {
        fieldType: 'FULL_NAME_FIRST_NAME'
      }
    }, {
      id: LAST_NAME_FIELD_ID,
      target: 'last_name',
      pii: true,
      validation: {
        string: {},
        required: lastNameRequired
      },
      view: {
        fieldType: 'FULL_NAME_LAST_NAME'
      }
    }],
    formFields: [{
      id: FIRST_NAME_FIELD_ID,
      hidden: false,
      identifier: 'FULL_NAME_FIRST_NAME',
      fieldType: FieldFieldType.INPUT,
      inputOptions: {
        inputType: InputFieldInputType.STRING,
        pii: true,
        target: 'first_name',
        required: firstNameRequired,
        stringOptions: {
          componentType: InputFieldStringComponentType.TEXT_INPUT,
          textInputOptions: {
            showLabel: true
          }
        }
      }
    }, {
      id: LAST_NAME_FIELD_ID,
      hidden: false,
      identifier: 'FULL_NAME_LAST_NAME',
      fieldType: FieldFieldType.INPUT,
      inputOptions: {
        inputType: InputFieldInputType.STRING,
        pii: true,
        target: 'last_name',
        required: lastNameRequired,
        stringOptions: {
          componentType: InputFieldStringComponentType.TEXT_INPUT,
          textInputOptions: {
            showLabel: true
          }
        }
      }
    }],
    steps: [{
      id: STEP_ID,
      layout: {
        large: {
          items: [{
            fieldId: leftId,
            row: 0,
            column: 0,
            width: 6,
            height: 1
          }, {
            fieldId: rightId,
            row: 0,
            column: 6,
            width: 6,
            height: 1
          }]
        },
        small: {
          items: [{
            fieldId: leftId,
            row: 0,
            column: 0,
            width: 12,
            height: 1
          }, {
            fieldId: rightId,
            row: 1,
            column: 0,
            width: 12,
            height: 1
          }]
        }
      }
    }]
  };
}
//# sourceMappingURL=create-full-name-form-schema.js.map